import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { RoutingState } from '../services/RoutingState';
import { AuthService } from '../services/AuthService';
import { ProfileService } from 'src/core/services/ProfileService';

@Injectable({ providedIn: 'root' })
export class AuthorizedGuard  {

    constructor(private router: Router,
                private authService: AuthService,
                private profileService: ProfileService,
                private routingState: RoutingState) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // verify that user is logged in
        const auth = this.authService.verify().pipe(
            map(data => {
                if (data) {
                    return true;
                }

                // error when verify so redirect to login page with the return url
                this.router.navigate(['/account/login'], { queryParams: { returnurl: state.url } });
                return false;
            }));

        return auth.pipe(
            switchMap((a, i) => this.profileService.load().pipe(
                switchMap((b, j) => this.routingState.ready().pipe(map(c => a && c)))
            ))
        );
        // return forkJoin([auth, this.profileService.load(), this.routingState.ready()]).pipe(map(a => a[0] && a[2]));
    }
}

